import { useState, useEffect } from "react";
import {
  getbarberAvailabilty,
  updateBarberAvailability,
  createBarberAvailability,
  deleteBarberAvailability,
} from "../../api/barberAvailabiltyApi";
import { getbarbers } from "../../api/barberApi";
import { useAuth } from "../../context/AuthContext";
import EditIcon from "../../assets/icons/edit-icon.png";
import DeleteIcon from "../../assets/icons/delete-icon.png";
import saveIcon from "../../assets/icons/save-icon.png";
const useBarberAvailability = () => {
  const [availabilty, setAvailabilty] = useState(null);
  const [barberList, setBarberList] = useState([]);
  const [barberAvailabilies, setBarberAvailabilies] = useState([]);
  const [selectedBarber, setSelectedBarber] = useState({});
  const [editId, seteditId] = useState();
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [unUsedDays, setUnusedDays] = useState(null);
  const getUnusedDays = (usedDays) => {
    let unUsedDays = daysOfWeek.filter((day) => !usedDays.includes(day.id));
    setUnusedDays(unUsedDays);
  };
  const daysOfWeek = [
    { id: 0, name: "Sunday" },
    { id: 1, name: "Monday" },
    { id: 2, name: "Tuesday" },
    { id: 3, name: "Wednesday" },
    { id: 4, name: "Thursday" },
    { id: 5, name: "Friday" },
    { id: 6, name: "Saturday" },
  ];
  const getDayName = (dayNumber) =>
    [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ][dayNumber];
  const columns = [
    { header: "Day", accessor: "day", render: (row) => getDayName(row.day) },
    { header: "Start Time", accessor: "startTime" },
    { header: "End Time", accessor: "endTime" },
    {
      header: "Actions",
      render: (row, { onEdit, onDelete }) => (
        <>
          <button className="btn btn-edit " onClick={() => onEdit(row.id)}>
            <img src={EditIcon} />
          </button>
          <button className="btn btn-delete" onClick={() => onDelete(row)}>
            <img src={DeleteIcon} />
          </button>
        </>
      ),
    },
  ];
  const { user } = useAuth();
  useEffect(() => {
    fetchBarbers();
  }, []);
  useEffect(() => {
    if (selectedBarber) {
      fetchBarberAvailabilties();
    }
  }, [selectedBarber]);
  useEffect(() => {
    getUnusedDays(barberAvailabilies.map((ba) => ba.day));
  }, [barberAvailabilies]);

  useEffect(() => {
    if (!showMessage) {
      setMessage(null);
    }
  }, [showMessage]);

  const fetchBarbers = async () => {
    const response = await getbarbers(user.barberShop);
    setBarberList(response);
    setSelectedBarber(response[0]);
  };
  const fetchBarberAvailabilties = async () => {
    if (selectedBarber) {
      const response = await getbarberAvailabilty(
        user.barberShop,
        selectedBarber.id,
      );

      setBarberAvailabilies(response);
    }
  };
  const handleConfirmDelete = async () => {
    const response = await deleteBarberAvailability(
      user.barberShop,
      selectedBarber.id,
      availabilty.id,
    );
    if (response.success == true) {
      setMessage({ text: response.message, type: "success" });
      setShowMessage(true);
      setShowDeleteModal(false);
      setAvailabilty(null);
      fetchBarberAvailabilties();
    } else {
      setMessage({ text: "Delete is failed", type: "failed" });
      setShowMessage(true);
      setShowDeleteModal(false);
      setAvailabilty(null);
    }
  };
  const handleDeleteClick = (availability) => {
    setAvailabilty(availability);
    setShowDeleteModal(true);
  };
  const onCloseDeleteModal = () => {
    setAvailabilty(null);
    setShowDeleteModal(false);
  };
  const editAvailability = (id) => {
    let availabilty = barberAvailabilies.find((a) => a.id == id);
    setAvailabilty(availabilty);
    seteditId(id);
    setShowModal(true);
  };
  const onCloseModalClick = () => {
    setShowModal(false);
    seteditId(null);
    setAvailabilty(null);
  };

  const onAddNewAvailabilty = () => {
    setShowModal(true);
    seteditId(null);
    setAvailabilty(null);
  };

  const onSave = async ({ day, startTime, endTime }) => {
    if (editId && availabilty) {
      const editAvailabilityData = {
        ShopId: user.barberShop,
        staffId: selectedBarber.id,
        id: availabilty.id,
        day: day.id,
        startTime: startTime,
        endTime: endTime,
      };
      const response = await updateBarberAvailability(
        user.barberShop,
        editAvailabilityData,
      );
      if (response && editId == response.data.availabilityId) {
        setShowModal(false);
        seteditId(null);
        setMessage({ text: response.data.message, type: "success" });
        setShowMessage(true);
        setAvailabilty(null);
        fetchBarberAvailabilties();
      } else {
        setMessage({
          text: "Failed to update the availability",
          type: "danger",
        });
        setShowMessage(true);
      }
    } else {
      const newAvailabilityData = {
        ShopId: user.barberShop,
        BarberId: selectedBarber.id,
        day: day.id,
        startTime: startTime,
        endTime: endTime,
      };
      const response = await createBarberAvailability(
        user.barberShop,
        newAvailabilityData,
      );
      setShowModal(false);
      seteditId(null);
      setMessage({ text: response.data.message, type: "success" });
      setShowMessage(true);
      setAvailabilty(null);
      fetchBarberAvailabilties();
    }
  };

  return {
    barberList,
    barberAvailabilies,
    selectedBarber,
    message,
    showMessage,
    setShowMessage,
    showDeleteModal,
    setSelectedBarber,
    editId,
    unUsedDays,
    editAvailability,
    showModal,
    columns,
    setShowModal,
    handleConfirmDelete,
    handleDeleteClick,
    onCloseDeleteModal,
    onCloseModalClick,
    onSave,
    onAddNewAvailabilty,
    availabilty,
  };
};
export default useBarberAvailability;
